import { CardHeading } from "../../../../src/components/article-elements/CardHeading.tsx";
import { OTJRatings } from "../../../../src/data/articles/usmans-deep-dive-on-outlaws-of-thunder-junction/Ratings.tsx";
import { NayaDeck } from "../../../../src/data/articles/usmans-deep-dive-on-outlaws-of-thunder-junction/NayaDeck.tsx";
import * as React from 'react';
export default {
  CardHeading,
  OTJRatings,
  NayaDeck,
  React
};